import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';

import {
  academyProjectModalStageSelector,
  ACADEMY_PROJECT_MODAL_STAGES,
  setAcademyProject,
  setAcademyProjectModalStage,
} from 'features/classCreation';
import AcademyProjectModalStageRenderer from '../AcademyProjectModalStageRenderer';

export default function AcademyProjectModal() {
  const dispatch = useDispatch();
  const modalStage = useSelector(academyProjectModalStageSelector);
  const isOpen = modalStage !== ACADEMY_PROJECT_MODAL_STAGES.notOpen;

  const handleModalClose = useCallback(() => {
    batch(() => {
      dispatch(
        setAcademyProjectModalStage(ACADEMY_PROJECT_MODAL_STAGES.notOpen)
      );
      dispatch(setAcademyProject(null));
    });
  }, [dispatch]);

  return (
    <Modal
      isOpen={isOpen}
      withoutHeader
      onClose={handleModalClose}
      unMountOnClose
      size="extraLarge"
      className="p-m"
    >
      <AcademyProjectModalStageRenderer />
    </Modal>
  );
}
